import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { successNotification, errorNotification } from "../components/notifications/alertNotification";
import { REQUEST_METHOD, STATUSES } from "../config/constants/defaultValues";
import { ESTIMATE_FORM_LIST_API } from "../config/constants/endPoints";
import { apiService } from "../config/services/api.service";


export const getEstimateFormListRequest = createAsyncThunk(
    "autoCompleteApprovalRequest/getAutoCompleteApprovalRequest",
    async ({ generalSearch, page, pageSize, dateRange }, { rejectWithValue }) => {
        try {
            const response = await apiService(
                ESTIMATE_FORM_LIST_API,
                REQUEST_METHOD.POST,
                {
                    "pagination": { "page": page ?? 1, "per_page": pageSize ?? 30, "export": "0" },
                    "query": { "status": "", "generalSearch": generalSearch, "dateRange": dateRange ?? "" }
                },
                true,
            );
            if (response.status === 200) {
                return response.data.data;
            } else {
                return errorNotification(Object.values(response.data.errors));
            }
        } catch (error) {
            errorNotification("Something went wrong")
            return rejectWithValue("Something went wrong");
        }
    }
);
export const getEstimateFormExportListRequest = createAsyncThunk(
    "autoCompleteApprovalRequest/getEstimateFormExportListRequest",
    async ({ generalSearch, page, dateRange }, { rejectWithValue }) => {
        try {
            const response = await apiService(
                ESTIMATE_FORM_LIST_API,
                REQUEST_METHOD.POST,
                {
                    "pagination": { "page": 1, "per_page": 30, "export": "1" },
                    "query": { "status": "", "generalSearch": generalSearch, "dateRange": dateRange ?? "" }
                },
                true,
            );
            if (response.status === 200) {
                return response.data.data;
            } else {
                return errorNotification(Object.values(response.data.errors));
            }
        } catch (error) {
            errorNotification("Something went wrong")
            return rejectWithValue("Something went wrong");
        }
    }
);

const estimateFormListSlice = createSlice({
    name: "autoCompleteApprovalRequest",
    initialState: {
        estimateFormData: null,
        status: STATUSES.IDLE,
        error: null,
    },
    extraReducers: {
        [getEstimateFormListRequest.pending]: (state, action) => {
            state.status = STATUSES.LOADING;
        },
        [getEstimateFormListRequest.fulfilled]: (state, action) => {

            state.status = STATUSES.IDLE;
            state.estimateFormData = action.payload;
        },
        [getEstimateFormListRequest.rejected]: (state, action) => {
            state.status = STATUSES.ERROR;
            state.error = action.payload;
        },
    },
});
export default estimateFormListSlice.reducer;

